export enum LoopType {
	LoopRecords,
	LoopArrayItems,
}
